import { createSelector } from '@reduxjs/toolkit'
import Panel from '~/components/UIKit/Panel'
import { RootState } from '~/store'
import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { SELECTED_WALL_SEGMENT_PANEL } from '~/store/panel/types'
import { SegmentsSection } from '../SelectedWallPanel'
import { updateObjects } from '~/store/objects'
import { MetadataFields } from '~/components/MetadataFields'

const selectSegments = createSelector(
  [(state: RootState) => state.selectedObjects, (state: RootState) => state.objects.present.segments],
  (selectedObjects, segments) =>
    Object.values(segments).filter(segment => selectedObjects.some(selected => selected.id === segment.id))
)

export default function SelectedWallSegmentPanel({ alignment = 'right' }: { alignment?: string }) {
  const dispatch = useAppDispatch()
  const isTouchUI = useAppSelector(state => state.userInterface.isTouchUI)
  const segments = useAppSelector(selectSegments)

  return (
    <Panel
      title="Wall"
      alignment={alignment}
      scrollable
      docked
      panelKey={SELECTED_WALL_SEGMENT_PANEL}
      hasToolbar={isTouchUI}
    >
      <SegmentsSection segments={segments} />
      <MetadataFields
        onChange={(fieldName, newValue) => {
          dispatch(
            updateObjects(
              segments.map(segment => ({ ...segment, metadata: { ...segment.metadata, [fieldName]: newValue } }))
            )
          )
        }}
        onDeleteImage={updatedSegment => dispatch(updateObjects([updatedSegment]))}
        selectedObjects={segments}
      />
    </Panel>
  )
}
